import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  fields: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0.5rem',
    width: '100%',
    boxSizing: 'border-box',
    maxHeight: '175px',
    overflow: 'auto',
    backgroundColor: 'rgb(245, 246, 248)',
    border: '1px solid #C6C6C6',
    borderRadius: 4
  },

  selected: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'rgb(245, 246, 248)',
    border: '1px solid #C6C6C6',
    borderRadius: 4,
    padding: 16,
    width: '100%',
    boxSizing: 'border-box'
  },
  selectedAction: {
    cursor: 'pointer'
  },
  field: {
    cursor: 'pointer',
    margin: '0.25rem 0px',
    padding: '0px 16px',

    '&:hover': {
      backgroundColor: '#E5E5E5'
    }
  }
}))

export default useStyles
